export const ERROR_VIEW_CODE = { // eslint-disable-line import/prefer-default-export
    GENERIC: 0,
    SERVICE_FAILURE: 1,
    UNREACHABLE_SITE: 2,
    BLOCKED_SITE: 3,
    TIMED_OUT_SITE: 4,
    BAD_CLIENT_BROWSER_LOCATION: 5,
    CLOSED_BY_NATURAL_CAUSE: 6,
    BLOCKED_UNSAFE: 7,
    NOT_WEBMAIL: 8,
    DOCUMENT_RENDER_ERROR: 9,
    DOWNLOAD_DISABLED: 10,
    NEVER_ISOLATE: 12,
    RESERVING_BROWSER: 13,
    NEVER_ISOLATE_INSTANT: 14,
    EMPTY_PAGE_CONTENT: 15,
};

export const CONTROL_MODE = {
    AUDIT: 'audit'
};

export const POLICY_MIGRATION_STEP_ENUM = {
    OLD_ONLY: 'OLD_ONLY',
    NEW_IN_TEST: 'NEW_IN_TEST',
    OLD_INACTIVE: 'OLD_INACTIVE',
    NEW_ONLY: 'NEW_ONLY'
};

export const REV_TYPE = {
    RULE: 'rule',
    BROWSING_ROLE: 'BrowsingRole',
    PRIORITY_CHANGED: 'PRIORITY_CHANGED',
    USER_GROUP_SOURCE_CHANGED: 'USER_GROUP_SOURCE_CHANGED',
};

export const RULE_REC_TYPE = {
    CONTENT_RULES: 'ContentRule',
    EXCLUSION_RULES: 'ExclusionRule',
    REDIRECT_RULES: 'RedirectRule',
    FILE_THREAT_RULES: 'FileThreatRule',
    DLP_RULES: 'DLPRule',
    CUSTOM_CATEGORIES: 'CustomerCategory',
};
